<template>
    <div>
        <div class="popstyle" v-bind:style="{display:parsedLocalizado}">
            <b-modal class="fixedModal" ref="myModal" size="lg" id="modal1" :title="'Comercio Google: '+comercial.name" centered :hide-footer="true" @hidden="onHidden">
                Dirección: {{comercial.vicinity}}
                <b-row>
                    <b-col style="text-align: right;">
                        <b-button @click="localizar">Localizar</b-button>
                    </b-col>
                </b-row>
            </b-modal>
        </div>
    </div>
</template>

<script>
export default {
  name: 'GoogleTooltip',
  props: ['comercial', 'permisos'],
  data () {
    return {
      localizado: false
    };
  },
  mounted: function () {
    this.$refs.myModal.show();
  },
  computed: {
    parsedLocalizado: function () {
      if (this.localizado) {
        return 'none';
      } else {
        return 'block';
      }
    }
  },
  methods: {
    onHidden: function () {
      this.$emit('hide');
    },
    localizar: function () {
      this.localizado = true;
      this.$emit('setLocation');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Modules/GoogleTooltip.vue